import type { IClubGetBenefitsItemData, IClubGetPlanAvailableData, IClubGetTermsData } from '../../services/types/club';

export const Types = {
  SET_CLUB_BENEFITS: 'offer_club/SET_CLUB_BENEFITS',
  SET_TERMS_CONDITIONS: 'offer_club/SET_TERMS_CONDITIONS',
  SET_CLUB_OFFER: 'offer_club/SET_CLUB_OFFER',
  SET_TRANSACTION_ID: 'offer_club/SET_TRANSACTION_ID',
  SET_SUBSCRIBED_STATUS: 'sigin_club/SET_SUBSCRIBED_STATUS',
  SET_MEMBER_NUMBER: 'offer_club/SET_MEMBER_NUMBER',
};

export interface IClubOfferReduxState {
  benefits: IClubGetBenefitsItemData[];
  termsConditions: IClubGetTermsData;
  offer: IClubGetPlanAvailableData;
  transactionId: number | string | null;
  subscribed: boolean;
  memberNumber: string;
}

const initialState: IClubOfferReduxState = {
  benefits: [],
  termsConditions: {
    title: '',
    content: '',
  },
  offer: {
    id: '',
    milesQuantity: '',
    monthlyCost: '',
    name: '',
  },
  transactionId: null,
  subscribed: false,
  memberNumber: '',
};

export default function reducer(state = initialState, action: any = {}): IClubOfferReduxState {
  switch (action.type) {
    case Types.SET_CLUB_BENEFITS:
      return { ...state, benefits: action.payload };
    case Types.SET_TERMS_CONDITIONS:
      return { ...state, termsConditions: action.payload };
    case Types.SET_CLUB_OFFER:
      return { ...state, offer: action.payload };
    case Types.SET_TRANSACTION_ID:
      return { ...state, transactionId: action.payload };
    case Types.SET_SUBSCRIBED_STATUS:
      return { ...state, subscribed: action.payload };
    case Types.SET_MEMBER_NUMBER:
      return { ...state, memberNumber: action.payload };
    default:
      return state;
  }
}

const setMemberNumber = (memberNumber: IClubOfferReduxState['memberNumber']) => ({
  type: Types.SET_MEMBER_NUMBER,
  payload: memberNumber,
});

const setTermsConditions = (payload: IClubOfferReduxState['termsConditions']) => ({
  type: Types.SET_TERMS_CONDITIONS,
  payload,
});

const setBenefits = (payload: IClubOfferReduxState['benefits']) => ({
  type: Types.SET_CLUB_BENEFITS,
  payload,
});

const setClubOfferData = (payload: IClubOfferReduxState['offer']) => ({
  type: Types.SET_CLUB_OFFER,
  payload,
});

const setSubscriptionStatus = (payload: IClubOfferReduxState['subscribed']) => ({
  type: Types.SET_SUBSCRIBED_STATUS,
  payload,
});

const setTransactionId = (payload: IClubOfferReduxState['transactionId']) => ({
  type: Types.SET_TRANSACTION_ID,
  payload,
});

export const ClubOfferActions = {
  setMemberNumber,
  setTermsConditions,
  setBenefits,
  setClubOfferData,
  setSubscriptionStatus,
  setTransactionId,
};
